export const TOKENS = {
  FBET: 'FBET',
  BBET: 'BBET',
  XBT: 'XBT',
  BUSD: 'BUSD',
  BNB: 'BNB'
};
